import fetch from './fetch'

/** ************** book 图书中心，包含图书分类、图书列表、图书搜索等功能 ***************/

// 微信签名
export function getWechatConfig () {
  return fetch({
    url: '/open/pay/wx/config',
    method: 'get',
  })
}

// 全部分类
export function getAllCateByTypeName () {
  return fetch({
    url: '/goods/categories',
    method: 'get',
  })
}

// 畅销标签
export function getAllTags () {
  return fetch({
    url: '/goods/tags',
    method: 'get',
  })
}

// 畅销标签图书
export function getTagBooks (tagId) {
  return fetch({
    url: `/goods/tags/${tagId}/books`,
    method: 'get',
  })
}

// 分类图书
export function getBookByCategoryId (params) {
  let categoryId = params.categoryId
  delete params.categoryId
  return fetch({
    url: `/goods/categories/${categoryId}/books`,
    method: 'get',
    params,
  })
}

// 图书详情
export function getBookDetail (bookId) {
  return fetch({
    url: `/store/goodsapi/goods/${bookId}`,
    method: 'get',
  })
}

export function getBookDesc (bookId) {
  return fetch({
    url: `/store/goodsapi/goods/${bookId}/desc`,
    method: 'get',
  })
}

export function getAuthor (bookId) {
  return fetch({
    url: `/store/goodsapi/goods/${bookId}/authors_and_drawers`,
    method: 'get',
  })
}

// 关键字查询
export function searchByWord (params) {
  return fetch({
    url: '/goods/books/searched',
    method: 'get',
    params,
  })
}

/** ***********QA谈，包含QA谈列表、QA谈详情等************** */

// QA谈
export function getQaTalkByPage (params) {
  return fetch({
    url: `/common/qatalk`,
    method: 'get',
    params,
  })
}

// 获取QA谈的详情
export function getQaDetail (id) {
  return fetch({
    url: `/common/qatalk/${id}`,
    method: 'get',
  })
}

// 最近的QA谈，用于首页展示。
export function getLastestQa () {
  return fetch({
    url: `/common/qatalk/latest`,
    method: 'get',
  })
}

/** ********************news 公司动态，包含公司动态列表等功能*********************/

// 公司动态展示
export function getAllNews () {
  return fetch({
    url: `/common/news`,
    method: 'get',
  })
}

// 公司动态详情
export function getNewsDetailById (newsId) {
  return fetch({
    url: `/common/news/${newsId}`,
    method: 'get',
  })
}

/** *****************job 人员招聘，展示公司招聘信息等******************* */

// 获取整个招聘部门信息
export function getAllDepartments () {
  return fetch({
    url: '/common/jobs/departments',
    method: 'get',
  })
}

// 部门招聘
export function getDepartmentDetail (params) {
  return fetch({
    url: `/common/jobs/departments/${params.id}`,
    method: 'get',
    params,
  })
}

// 招聘详情
export function getJobsDetail (id) {
  return fetch({
    url: `/common/jobs/${id}`,
    method: 'get',
  })
}

/** ****************partner 授权商，包含授权商查询等功能***************** */
// 授权商查询
export function queryPartners (params) {
  return fetch({
    url: `/common/partners`,
    method: 'get',
    params,
  })
}
